export const CQI_BASE_URL = 'aggregations/kloe'

export enum CQITabID {
  Safe = 'safe',
  Effective = 'effective',
  Caring = 'caring',
  Responsive = 'responsive',
  WellLed = 'well-led'
}

export type TablesDataSource = {
  key: string
  indicator: string
  timeframe: string
  output: string | number | undefined
}

export const getRoundedPercentage = (initialNumber: number): `${number}%` => {
  const percentage = initialNumber * 100
  const roundedPercentage = Math.round(percentage)

  return `${roundedPercentage}%`
}
